const zIndices = {
  codeBlockCopyButton: 100,
  progress: 1000,
}

export default zIndices
